export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7482.6c02ebee.jpg";